export const Blogs = [
    {
      id: 16,
      name: "Leetcode coding profile",
      tags: ["leetcode", "dsa", "java"],
      //date: "brute better optimal repeat",
      imgSrc: "https://res.cloudinary.com/dqvpvazim/image/upload/c_crop,g_auto,h_800,w_800/LeetCode_itwpyu.jpg",
      link: "https://leetcode.com/ashwinnn28/",
    },
    {
      id: 15,
      name: "Crash Course on Python",
      tags: ["Basic Python Syntax", "Python Programming", "Object-Oriented Programming (OOP)"],
      date: "6 weeks program",
      imgSrc:"https://res.cloudinary.com/dqvpvazim/image/upload/e_improve:outdoor/python-cerficate_qrommk.jpg",
      link: "https://www.coursera.org/account/accomplishments/verify/Z8T2QTPABKYE?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=pdf_header_button&utm_product=course",
    },
    {
      id: 14,
      name: "Ediify Techno - Full Stack Web Developer",
      tags: ["HTML", "CSS", "BootStrap", "JavaScript","React","Github"],
      date: "Worked on Real world projects and Collaborated using GitHub by using conventional commits",
      imgSrc:"https://res.cloudinary.com/dqvpvazim/image/upload/c_crop,g_auto,h_800,w_800/intern_ebxsmx.jpg",
      link: "https://res.cloudinary.com/dqvpvazim/image/upload/e_improve:outdoor:80/rbih2d3tagg8ir3gztxm.jpg",
    }

  ];
  